import * as React from 'react';
import * as RequestParams from '../config/RequestParams';
import * as BannerParamsAPI from '../api/bannerParams';
import * as MatchAPI from '../api/match';
import * as Types from '../Types';
import useHistory from '../hooks/useHistory';
import { MatchFormatter } from '../utils';
export function useConfigurator(requestParams, config) {
    const [error, setError] = React.useState(null);
    const [bannerParams, setBannerParams] = React.useState(null);
    const [visibleSize, setVisibleSize] = React.useState();
    const [newSlideDescription, setNewSlideDescription] = React.useState({
        type: Types.SlideType.Match
    });
    const [creatives, setCreatives] = React.useState([]);
    const [outrightOutcomes, setOutrightOutcomes] = React.useState(null);
    const license = config.getLicense(config);
    const { pushUrl } = useHistory();
    const defaultSlides = config.getDefaultSlides(requestParams.language);
    React.useEffect(() => {
        BannerParamsAPI.getBannerParams(config.apiHost, {
            sport: requestParams.sport,
            region: requestParams.region,
            league: requestParams.league,
            team: requestParams.team,
            language: requestParams.language,
            license,
            supportedSports: config.supportedSports ? config.supportedSports.join(',') : undefined
        })
            .then(([, params]) => {
            setBannerParams(params || null);
        })
            .catch(([error]) => {
            setError(error);
            setBannerParams(null);
        });
    }, [requestParams, license]);
    React.useEffect(() => {
        if (requestParams.contestId) {
            MatchAPI.getMatches(config.apiHost, {
                language: requestParams.language,
                contestId: requestParams.contestId
            }).then(([error, matches]) => {
                if (matches && matches.length === 1) {
                    const betmarket = MatchFormatter.getBetmarketOfType(matches[0].betmarkets, MatchAPI.BettingType.Place);
                    if (betmarket) {
                        setOutrightOutcomes(betmarket.odds.map(odds => odds.outcome).sort());
                    }
                    else {
                        setOutrightOutcomes(null);
                    }
                }
            });
        }
        else {
            setOutrightOutcomes(null);
        }
    }, [requestParams]);
    function getCurrentUrl() {
        // const url = new URL(window.location.href);
        // Object.entries(requestParams).forEach(([key, value]) => {
        //     const defaultValue = config.defaults[key];
        //     if (value !== undefined && value !== defaultValue) url.searchParams.set(key, value);
        // });
        return new URL(window.location.href);
    }
    function setParameter(key, value) {
        const url = getCurrentUrl();
        const adServerClickPrefix = url.searchParams.get(RequestParams.RequestParam.adServerClickPrefix);
        url.searchParams.delete(RequestParams.RequestParam.adServerClickPrefix);
        switch (key) {
            case RequestParams.RequestParam.contestId:
                url.searchParams.delete(RequestParams.RequestParam.outrightOutcome);
                if (value) {
                    url.searchParams.set(RequestParams.RequestParam.market, MatchAPI.BettingType.Place);
                }
                else {
                    url.searchParams.delete(RequestParams.RequestParam.market);
                }
                break;
            case RequestParams.RequestParam.sport:
                url.searchParams.delete(RequestParams.RequestParam.region);
                url.searchParams.delete(RequestParams.RequestParam.league);
                url.searchParams.delete(RequestParams.RequestParam.team);
                if (url.searchParams.get(RequestParams.RequestParam.contestId)) {
                    url.searchParams.delete(RequestParams.RequestParam.market);
                    url.searchParams.delete(RequestParams.RequestParam.contestId);
                    url.searchParams.delete(RequestParams.RequestParam.outrightOutcome);
                }
                break;
            case RequestParams.RequestParam.region:
                url.searchParams.delete(RequestParams.RequestParam.league);
                url.searchParams.delete(RequestParams.RequestParam.team);
                if (url.searchParams.get(RequestParams.RequestParam.contestId)) {
                    url.searchParams.delete(RequestParams.RequestParam.market);
                    url.searchParams.delete(RequestParams.RequestParam.contestId);
                    url.searchParams.delete(RequestParams.RequestParam.outrightOutcome);
                }
                break;
            case RequestParams.RequestParam.league:
                url.searchParams.delete(RequestParams.RequestParam.team);
                if (url.searchParams.get(RequestParams.RequestParam.contestId)) {
                    url.searchParams.delete(RequestParams.RequestParam.market);
                    url.searchParams.delete(RequestParams.RequestParam.contestId);
                    url.searchParams.delete(RequestParams.RequestParam.outrightOutcome);
                }
                break;
            case RequestParams.RequestParam.template:
                url.hash = '';
                break;
            default:
                break;
        }
        if (value) {
            if (Array.isArray(value)) {
                url.searchParams.delete(key);
                value.forEach(v => url.searchParams.append(key, v));
            }
            else {
                url.searchParams.set(key, value);
            }
        }
        else {
            url.searchParams.delete(key);
        }
        if (key !== RequestParams.RequestParam.adServerClickPrefix && adServerClickPrefix) {
            url.searchParams.set(RequestParams.RequestParam.adServerClickPrefix, adServerClickPrefix);
        }
        pushUrl(url.toString());
    }
    function getParameter(key) {
        const url = getCurrentUrl();
        return url.searchParams.get(key) || undefined;
    }
    function updatePassThroughParameters(index, newEntry) {
        const passThrough = getPassThroughParameters();
        const url = getCurrentUrl();
        const adServerClickPrefix = url.searchParams.get(RequestParams.RequestParam.adServerClickPrefix);
        url.searchParams.delete(RequestParams.RequestParam.adServerClickPrefix);
        passThrough.forEach(([k, v]) => {
            url.searchParams.delete(RequestParams.toPassThroughParameter(k));
        });
        passThrough[index] = newEntry;
        passThrough
            .filter(([k, v]) => k !== undefined && k !== '')
            .forEach(([k, v]) => {
            url.searchParams.append(RequestParams.toPassThroughParameter(k), v);
        });
        if (adServerClickPrefix) {
            url.searchParams.append(RequestParams.RequestParam.adServerClickPrefix, adServerClickPrefix);
        }
        pushUrl(url.toString());
    }
    function getPassThroughParameters() {
        const entries = [];
        const url = getCurrentUrl();
        url.searchParams.forEach((value, key) => {
            if (RequestParams.isPassThroughParameter(key)) {
                entries.push([RequestParams.fromPassThroughParameter(key), value]);
            }
        });
        entries.push(['', '']);
        return entries;
    }
    function updateVisibleSize(size) {
        window.location.hash = size;
    }
    function updateSlideDescriptions(slideDescriptions) {
        setParameter(RequestParams.RequestParam.campaignCount, '');
        setParameter(RequestParams.RequestParam.matchCount, '');
        setParameter(RequestParams.RequestParam.slide, slideDescriptions.map(RequestParams.encodeSlideDescription));
    }
    function addSlideDescription() {
        switch (newSlideDescription.type) {
            case Types.SlideType.Creative:
                if (!newSlideDescription.id)
                    return null;
                updateSlideDescriptions(requestParams.slide.concat({ type: Types.SlideType.Creative, id: newSlideDescription.id }));
                break;
            case Types.SlideType.Campaign:
                updateSlideDescriptions(requestParams.slide.concat({ type: Types.SlideType.Campaign }));
                break;
            case Types.SlideType.Match:
                updateSlideDescriptions(requestParams.slide.concat({ type: Types.SlideType.Match }));
                break;
            default:
                break;
        }
        setNewSlideDescription({ type: Types.SlideType.Match });
    }
    function moveSlideDescription(index, direction) {
        const newSlides = requestParams.slide.concat([]);
        const slideToMove = newSlides.splice(index, 1)[0];
        newSlides.splice(direction === 'up' ? Math.max(index - 1, 0) : index + 1, 0, slideToMove);
        updateSlideDescriptions(newSlides);
    }
    function removeSlideDescription(index) {
        const newSlides = requestParams.slide.filter((v, i) => index !== i);
        updateSlideDescriptions(newSlides);
    }
    function isSlideMandatory(slideDescription) {
        return Boolean([...defaultSlides.before, ...defaultSlides.after].find(sd => RequestParams.isEqualSlideDescription(sd, slideDescription)));
    }
    const validateVisibleSize = React.useCallback((hash) => {
        const valideConfiguratorSizes = [
            ...config.getSupportedSizesByTemplate(requestParams.template || config.defaults.template),
            'auto'
        ];
        return RequestParams.validateParam(hash.slice(1), valideConfiguratorSizes) || '';
    }, [requestParams.template]);
    React.useEffect(() => {
        setVisibleSize(validateVisibleSize(window.location.hash));
        function handleHashChange(event) {
            const url = new URL(event.newURL);
            setVisibleSize(validateVisibleSize(url.hash));
        }
        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, [validateVisibleSize]);
    React.useEffect(() => {
        config.loadCreatives(config).then(setCreatives);
    }, [config]);
    return {
        license,
        creatives,
        addSlideDescription,
        moveSlideDescription,
        removeSlideDescription,
        newSlideDescription,
        setNewSlideDescription,
        error,
        visibleSize,
        setVisibleSize: updateVisibleSize,
        bannerParams,
        setParameter,
        getParameter,
        getPassThroughParameters,
        updatePassThroughParameters,
        outrightOutcomes,
        isSlideMandatory
    };
}
//# sourceMappingURL=useConfigurator.js.map